import { SET_CONNECTION_STATUS } from '../actions/connectionStatus'

const initialState = {
  connectionStatus: navigator.onLine ? 'online' : 'offline'
}

export default function setConnectionStatus(state = initialState, action) {
  switch (action.type) {
    case SET_CONNECTION_STATUS:
      return {
        ...state,
        connectionStatus: action.connectionStatus
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/connectionStatus.js